! function(e) {
    e("#filter-sidebar") && History.Adapter.bind(window, "statechange", function() {
        History.getState();
        if (!t._sidebarAjaxClick) {
            t._sidebarparams();
            var e = t._sidebarcreateUrl();
            t._sidebargetContent(e), t._reactivesidebar()
        }
        t._sidebarAjaxClick = !1
    }), window.use_color_swatch && (e(".swatch :radio").change(function() {
        var i = e(this).closest(".swatch").attr("data-option-index"),
            t = e(this).val();
        e(this).closest("form").find(".single-option-selector").eq(i).val(t).trigger("change")
    }), Shopify.optionsMap = {}, Shopify.updateOptionsInSelector = function(i) {
        switch (i) {
            case 0:
                var t = "root",
                    a = e(".single-option-selector:eq(0)");
                break;
            case 1:
                t = e(".single-option-selector:eq(0)").val(), a = e(".single-option-selector:eq(1)");
                break;
            case 2:
                t = e(".single-option-selector:eq(0)").val();
                t += " / " + e(".single-option-selector:eq(1)").val();
                a = e(".single-option-selector:eq(2)")
        }
        var r = a.val();
        a.empty();
        for (var n = Shopify.optionsMap[t], o = 0; o < n.length; o++) {
            var c = n[o],
                d = e("<option></option>").val(c).html(c);
            a.append(d)
        }
        e('.swatch[data-option-index="' + i + '"] .swatch-element').each(function() {
            -1 !== e.inArray(e(this).attr("data-value"), n) ? e(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : e(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled")
        }), -1 !== e.inArray(r, n) && a.val(r), a.trigger("change")
    }, Shopify.linkOptionSelectors = function(i) {
        for (var t = 0; t < i.variants.length; t++) {
            var a = i.variants[t];
            if (a.available) {
                if (Shopify.optionsMap.root = Shopify.optionsMap.root || [], Shopify.optionsMap.root.push(a.option1), Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root), i.options.length > 1) {
                    var r = a.option1;
                    Shopify.optionsMap[r] = Shopify.optionsMap[r] || [], Shopify.optionsMap[r].push(a.option2), Shopify.optionsMap[r] = Shopify.uniq(Shopify.optionsMap[r])
                }
                if (3 === i.options.length) {
                    r = a.option1 + " / " + a.option2;
                    Shopify.optionsMap[r] = Shopify.optionsMap[r] || [], Shopify.optionsMap[r].push(a.option3), Shopify.optionsMap[r] = Shopify.uniq(Shopify.optionsMap[r])
                }
            }
        }
        Shopify.updateOptionsInSelector(0), i.options.length > 1 && Shopify.updateOptionsInSelector(1), 3 === i.options.length && Shopify.updateOptionsInSelector(2), e(".single-option-selector:eq(0)").change(function() {
            return Shopify.updateOptionsInSelector(1), 3 === i.options.length && Shopify.updateOptionsInSelector(2), !0
        }), e(".single-option-selector:eq(1)").change(function() {
            return 3 === i.options.length && Shopify.updateOptionsInSelector(2), !0
        })
    }), e(document).ready(function() {
        t.go()
    }), e(window).resize(function() {
        t._resizeImage()
    });
    var t = {
        atTimeout: null,
        _sidebarAjaxClick: !1,
        go: function() {
            this._resizeImage(), this._quickview(), this._sidebar(), this._zoomimage(), this._scrollTop(), this._headerdropcart(), this.translateBlock(".main-content"), this._addtocart(), this._quickshop(), this._mesagebox(), this._productaddtocart(), this._wishlist(), this._productwishlist(), this._removewishlist(), this._colorswatchgridInit(), this._infinitescrolling()
        },
        _infinitescrolling: function() {
            e(".infinite-scrolling").length > 0 && (e(".loading-product").hide(), e(".infinite-scrolling a").click(function(i) {
                i.preventDefault(), e(this).hasClass("disabled") || t.doInfiniteScrolling()
            }))
        },
        doInfiniteScrolling: function() {
            var i = e(".main_container .products-grid");
            if (i.length || (i = e(".main_container .product-list")), i) {
                var a = e(".infinite-scrolling a").first();
                e.ajax({
                    type: "GET",
                    url: a.attr("href"),
                    beforeSend: function() {
                        e(".loading-product").show()
                    },
                    success: function(r) {
                        t.hideLoading(), e(".loading-product").hide();
                        var n = e(r).find(".main_container .products-grid");
                        if (n.length || (n = e(r).find(".main_container .product-list-item")), n.length && (n.hasClass("products-grid") && window.product_image_resize && n.children().find("img").fakecrop({
                                fill: window.images_size.is_crop,
                                widthSelector: ".products-grid .grid-item .product-image",
                                ratioWrapper: window.images_size
                            }), i.append(n.children()), t._quickview(), t._addtocart(), t._wishlist(), e(r).find(".infinite-scrolling").length > 0 ? a.attr("href", e(r).find(".infinite-scrolling a").attr("href")) : (a.hide(), a.next().show()), e(".spr-badge").length > 0)) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                    },
                    error: function(i, a) {
                        t.hideLoading(), e(".loading-product").hide(), e(".ajax-error-message").text(e.parseJSON(i.responseText).description), t.showModal(".ajax-error-modal")
                    },
                    dataType: "html"
                })
            }
        },
        _colorswatchgridInit: function() {
            e(".color-swatch-item li a").on("click", function(i) {
                i.preventDefault(), e(this).parents(".product-inner").find(".grid-image").find("img.feature-images").attr("src", e(this).data("image"))
            })
        },
        _ajaxsidebar: function() {
            e(".sidebar-tag a, .sidebar-tag label").click(function(i) {
                var a = [];
                if (Shopify.queryParams.constraint && (a = Shopify.queryParams.constraint.split("+")), !window.enable_sidebar_multiple_choice && !e(this).prev().is(":checked")) {
                    var r, n, o = e(this).parents(".sidebar-tag").find("input:checked");
                    if (o.length > 0)
                        if (r = o.val())(n = a.indexOf(r)) >= 0 && a.splice(n, 1)
                }(r = e(this).prev().val()) && ((n = a.indexOf(r)) >= 0 ? a.splice(n, 1) : a.push(r));
                a.length ? Shopify.queryParams.constraint = a.join("+") : delete Shopify.queryParams.constraint, t.sidebarAjaxClick(), i.preventDefault()
            })
        },
        _evensidebar: function() {
            t._ajaxsidebar()
        },
        _checkitemdropcart: function() {
            e("#dropdown-cart .cart-list").children().length > 0 ? (e("#dropdown-cart .cart-empty").hide(), e("#dropdown-cart .mini_cart_header").show()) : (e("#dropdown-cart .mini_cart_header").hide(), e("#dropdown-cart .cart-empty").show())
        },
        _headerdropcart: function() {
            t._checkitemdropcart(), e("#dropdown-cart .cart-empty a").click(function() {
                e("#dropdown-cart").slideUp("fast")
            }), e("#dropdown-cart .btn-remove").click(function(i) {
                i.preventDefault();
                var a = e(this).parents(".item").attr("id");
                a = a.match(/\d+/g), Shopify.removeItem(a, function(i) {
                    t._headercartitem(i), e(this).addClass("remove-cart")
                })
            })
        },
        closeDropdownCart: function() {
            e("#dropdown-cart").is(":visible") && e("#dropdown-cart").slideUp("fast")
        },
        _accordionsibar: function() {
            e(".sidebar-tag").length > 0 && e(".sidebar-tag .widget-title span").click(function() {
                e(this).parents(".widget-title");
                t.hasClass("click") ? t.removeClass("click") : t.addClass("click"), e(this).parents(".sidebar-tag").find(".widget-content").slideToggle()
            })
        },
        _clearsidebarall: function() {
            e(".addlabel a").click(function(e) {
                e(this).each(function() {
                    var e = [];
                    e.length ? Shopify.queryParams.constraint = e.join("+") : (delete Shopify.queryParams.constraint, t.sidebarAjaxClick())
                })
            }), e("a.clear-all").click(function() {
                e(this).removeClass("active"), e("body").find(".addlabel").removeClass("active")
            }), e("#filter-sidebar a.clear-all").click(function(e) {
                delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, t.sidebarAjaxClick(), e.preventDefault()
            })
        },
        _clearsidebar: function() {
            e(".sidebar-tag").each(function() {
                var i = e(this);
                i.find("input:checked").length > 0 && (e(".wrapper-container").removeClass("show-fillter"), e("body").find(".clear-all").addClass("active"), e("body").find(".addlabel").addClass("active"), i.find(".clear-all").show().click(function(a) {
                    var n = [];
                    Shopify.queryParams.constraint && (n = Shopify.queryParams.constraint.split("+")), i.find("input:checked").each(function() {
                        var i = e(this),
                            a = t.val();
                        if (a) {
                            i = n.indexOf(a);
                            r >= 0 && n.splice(i, 1)
                        }
                    }), n.length ? Shopify.queryParams.constraint = n.join("+") : delete Shopify.queryParams.constraint, t.sidebarAjaxClick(), a.preventDefault()
                }))
            })
        },
        _evensidebar: function() {
            t._ajaxsidebar(), t._collectionlinkajax(), t._colorswatchgridInit()
        },
        _reactivesidebar: function() {
            e(".sidebar-custom .active, .sidebar-links .active").removeClass("active"), e(".sidebar-tag input:checked").attr("checked", !1);
            var i = location.pathname.match(/\/collections\/(.*)(\?)?/);
            if (i && i[1] && (e(".sidebar-links a[href='" + i[0] + "']").addClass("active"), e(".sidebar-tag").addClass("1111")), Shopify.queryParams.view) {
                e(".view-mode .active").removeClass("active");
                var t = Shopify.queryParams.view;
                t.indexOf("list") >= 0 ? (t(".view-mode .list").addClass("active"), t = t.replace("list", "")) : e(".view-mode .grid").addClass("active"), e(".filter-show > button span").text(t), e(".filter-show li.active").removeClass("active"), e(".filter-show a[href='" + t + "']").parent().addClass("active")
            }
        },
        _collectionlinkajax: function() {
            e(".sidebar-links a").click(function(i) {
                e(this).hasClass("active") || (delete Shopify.queryParams.q, t.sidebarAjaxClick(e(this).attr("href")), e(".sidebar-links a.active").removeClass("active"), e(this).addClass("active")), i.preventDefault()
            })
        },
        sidebarMapData: function(i) {
            var t = e(".col-main .products-grids");
            0 == t.length && (t = e(".col-main .product-list"));
            var a = e(i).find(".col-main .products-grids");
            0 == a.length && (a = e(i).find(".col-main .product-list"));
            var r = e(".col-main .products-grid");
            0 == r.length && (r = e(".col-main .product-list"));
            var n = e(i).find(".col-main .products-grid");
            0 == n.length && (n = e(i).find(".col-main .product-list")), n.length > 0 && n.hasClass("products-grid") && window.product_image_resize && n.find("img").fakecrop({
                fill: window.images_size.is_crop,
                widthSelector: ".products-grid .grid-item .product-image",
                ratioWrapper: window.images_size
            }), r.replaceWith(n), t.replaceWith(a), e(".padding").length > 0 ? e(".padding").replaceWith(e(i).find(".padding")) : e(".main-content .col-main").append(e(i).find(".padding"));
            var o = e(".page-header"),
                c = e(i).find(".page-header");
            o.find("h2").text() != c.find("h2").text() && (o.find("h2").replaceWith(c.find("h2")), o.find(".rte").length ? c.find(".rte").length ? o.find(".rte").replaceWith(c.find(".rte")) : o.find(".rte").hide() : c.find(".rte").length && o.find("h2").after(c.find(".rte"))), e(".addlabel").replaceWith(e(i).find(".addlabel")), e(".sidebar-block").replaceWith(e(i).find(".sidebar-block"))
        },
        _sidebarcreateUrl: function(i) {
            var t = e.param(Shopify.queryParams).replace(/%2B/g, "+");
            return i ? "" != t ? i + "?" + t : i : location.pathname + "?" + t
        },
        sidebarAjaxClick: function(e) {
            delete Shopify.queryParams.page;
            var i = t._sidebarcreateUrl(e);
            t._sidebarAjaxClick = !0, History.pushState({
                param: Shopify.queryParams
            }, i, i), t._sidebargetContent(i)
        },
        _sidebargetContent: function(i) {
            e.ajax({
                type: "get",
                url: i,
                beforeSend: function() {
                    t.showLoading(), e(".loadding-collection").show()
                },
                success: function(i) {
                    e(".loadding-collection").hide(), t.sidebarMapData(i), t._ajaxsidebar(), t._accordionsibar(), t._clearsidebar(), t._clearsidebarall(), t.hideLoading(), t._addtocart(), t._wishlist(), t._colorswatchgridInit(), t._quickview(), t._quickshop(), t._infinitescrolling()
                },
                error: function(i, a) {
                    t.hideLoading(), e(".loading-modal").hide(), e(".loadding-collection").hide(), e(".ajax-error-message").text(e.parseJSON(i.responseText).description), t.showModal(".ajax-error-modal")
                }
            })
        },
        _sidebarparams: function() {
            if (Shopify.queryParams = {}, location.search.length)
                for (var i, t = 0, a = location.search.substr(1).split("&"); t < a.length; t++) i = a[t].split("="), e.length > 1 && (Shopify.queryParams[decodeURIComponent(i[0])] = decodeURIComponent(i[1]))
        },
        _sidebar: function() {
            e("#filter-sidebar").length > 0 && (t._sidebarparams(), t._evensidebar(), t._accordionsibar(), t._clearsidebar(), t._clearsidebarall(), t._colorswatchgridInit(), t._quickview())
        },
        _wishlist: function() {
            e(".grid-item button.wishlist").click(function(e) {})
        },
        _productwishlist: function() {
            e(".product button.wishlist").click(function(e) {})
        },
        _removewishlist: function() {
            e(".btn-remove-wishlist").each(function() {
                e(this).click(function(i) {
                    i.preventDefault();
                    var t = e(this).parents("tr"),
                        a = t.find(".tag-id").val(),
                        r = jQuery("#remove-wishlist-form-" + a);
                    r.find("input[name='contact[tags]']").val("x" + a), t.fadeOut(300), setTimeout(r.submit(), 3e3)
                })
            })
        },
        _resizeImage: function() {
            window.product_image_resize && e(".products-grid .product-image img").fakecrop({
                fill: window.images_size.is_crop,
                widthSelector: ".products-grid .grid-item .product-image",
                ratioWrapper: window.images_size
            })
        },
        showBox: function(i) {
            e(i).fadeIn(500), t.atTimeout = setTimeout(function() {
                e(i).fadeOut(300)
            }, 5e3)
        },
        _mesagebox: function() {
            e(".continue-shopping").click(function() {
                clearTimeout(t.atTimeout), e(".ajax-success-cbox").fadeOut(500)
            }), e(".close-cbox").click(function() {
                clearTimeout(t.atTimeout), e(".ajax-success-cbox").fadeOut(500)
            })
        },
        _zoomimage: function() {
          	
          	var windowW = window.innerWidth;
          	
            e(".zoom").on("click", function(){
              if(e(this).find('#product-featured-image').length) {
                e("#product-featured-image").click();

                return false;
              }
            });
          
          	      
              e("#product-featured-image").on("click", function(i) {
                if($('#zt_list_product').length) {    
                  var t = e("#product-featured-image").data("elevateZoom");
                  
                  return e.fancybox(t.getGalleryList()), false;
                  
                } else {
                  var url = $(this).closest('a').attr('href');
                  return e.fancybox(url), false;
                }
              });
            
          
			if(windowW > 767) {
              if(e("#product-featured-image").length > 0) {
                e("#product-featured-image").elevateZoom({
					gallery: "zt_list_product",
					zoomType: "inner",
					onImageSwapComplete: function() {
						e(".gallery-images div").hide()
					},
					loadingIcon: window.loading_url
				});
                
                
              }
              
				
			}
          
			/*var windowW = window.innerWidth;
			if(windowW > 767) {
				e("#product-featured-image").length > 0 && (e("#product-featured-image").elevateZoom({
					gallery: "zt_list_product",
					zoomType: "inner",
					onImageSwapComplete: function() {
						e(".gallery-images div").hide()
					},
					loadingIcon: window.loading_url
				}), e("#product-featured-image").bind("click", function(i) {
					var t = e("#product-featured-image").data("elevateZoom");
					return e.fancybox(t.getGalleryList()), !1
				}))
			}*/
            
        },
        _scrollTop: function() {
            e("#back-top").click(function() {
                return e("body,html").animate({
                    scrollTop: 0
                }, 400), !1
            })
        },
        _productaddtocart: function() {
            e("#product-add-to-cart").length > 0 && e("#product-add-to-cart").click(function(i) {
                if (i.preventDefault(), "disabled" != e(this).attr("disabled"))
                    if (window.ajax_cart) {
                        var a = e("#add-to-cart-form select[name=id]").val();
                        a || (a = e("#add-to-cart-form input[name=id]").val());
                        var r = e("#add-to-cart-form input[name=quantity]").val();
                        r || (r = 1);
                        var n = e("#product-featured-image").attr("src");
                        t._ajaxaddtocart(a, r, n)
                    } else e(this).closest("form").submit();
                return !1
            })
        },
        _addtocart: function() {
            e(".add-to-cart-btn-new").length > 0 && e(".add-to-cart-btn-new").click(function(i) {
                if (i.preventDefault(), "disabled" != e(this).attr("disabled")) {
                    var a = e(this).parents(".product-item"),
                        r = e(a).attr("id");
                    if (r = r.match(/\d+/g), window.ajax_cart) {
                        var n = e("#product-actions-" + r + " select[name=id]").val();
                        n || (n = e("#product-actions-" + r + " input[name=id]").val());
                        var o = e("#product-actions-" + r + " input[name=quantity]").val();
                        o || (o = 1);
                        var c = e(a).find(".product-title").text();
                        t._ajaxaddtocart(n, o, c)
                    } else e("#product-actions-" + r).submit()
                }
                return !1
            })
        },
        showLoading: function() {
            e(".loading").show()
        },
        hideLoading: function() {
            e(".loading").hide()
        },
        _ajaxaddtocart: function(i, a, r, n) {
            e.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + a + "&id=" + i,
                dataType: "json",
                beforeSend: function() {
                    t.showLoading(), jQuery(".mini_cart_header").addClass("loading"), jQuery("#dropdown-cart").addClass("active"), jQuery(".wrapper-container").addClass("show-cart")
                },
                success: function(i) {
                    t.hideLoading(), e(".ajax-success-cbox").find(".product-title").html(t.translateText(i.title)), e(".ajax-success-cbox").find(".show-wishlist").hide(), e(".ajax-success-cbox").find(".show-cart").show(), t.showBox(".ajax-success-cbox"), e(".ajax-success-cbox").find(".show-wishlist").hide(), jQuery("#dropdown-cart").addClass("active"), jQuery(".wrapper-container").addClass("show-cart"), t._updateheadercart(), jQuery(".mini_cart_header").removeClass("loading")
                },
                error: function(i, a) {
                    t.hideLoading(), e(".ajax-error-message").text(e.parseJSON(i.responseText).description), t.showBox(".ajax-error-cbox")
                }
            })
        },
        _loadslideimagequickview: function(e, a) {
            var r = Shopify.resizeImage(e.featured_image, "grande");
            if (a.find(".quickview-featured-image").append('<a href="' + e.url + '"><img src="' + r + '" title="' + e.title + '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>'), e.images.length > 0) {
                var n = a.find(".more-view ul");
                for (i in e.images) {
                    var o = '<li><a href="javascript:void(0)" data-image="' + Shopify.resizeImage(e.images[i], "grande") + '"><img src="' + Shopify.resizeImage(e.images[i], "compact") + '"  /></a></li>';
                    n.append(o)
                }
                n.find("a").click(function() {
                    var e = a.find(".quickview-featured-image img"),
                        i = a.find(".quickview-featured-image div");
                    e.attr("src") != jQuery(this).attr("data-image") && (e.attr("src", jQuery(this).attr("data-image")), i.show(), e.load(function(e) {
                        i.hide(), jQuery(this).unbind("load"), i.hide()
                    }))
                }), n.hasClass("quickview-more-views-owlslider") && t._quickviewthumbslide(n)
            } else a.find(".quickview-more-views").remove(), a.find(".quickview-more-view-wrapper-jcarousel").remove()
        },
        _quickview: function() {
            jQuery(".quickview-button a").click(function() {
                console.log("lol1");
                var e = jQuery(this).attr("id");
                return Shopify.getProduct(e, function(e) {
                    var i = jQuery("#quickview-popup").html();
                    jQuery(".product-quickview").html(i), e.description.indexOf("pre-order-label") > 0 && (jQuery(".actions").addClass("pre"), jQuery(".actions .add-to-cart-btn-new").append("<span>Pre-Order</span>"));
                    var a = jQuery(".product-quickview");
                    if (a.find(".product-title a").html(t.translateText(e.title)), a.find(".product-title a").attr("href", e.url), a.find(".product-vendor span").length > 0 && a.find(".product-vendor span").text(e.vendor), a.find(".product-type span").length > 0 && a.find(".product-type span").text(e.type), a.find(".product-inventory span").length > 0) {
                        var r = e.variants[0].inventory_quantity;
                        r > 0 ? null != e.variants[0].inventory_management ? a.find(".product-inventory span").text(r + " in stock") : a.find(".product-inventory span").text("Many in stock") : a.find(".product-inventory span").text("Out of stock")
                    }
                    if (a.find(".product-description").length > 0) {
                        var n = (n = (n = (n = (n = (n = (n = (n = (n = (n = (n = e.description.replace(/(<([^>]+)>)/gi, "")).replace(/\[countdown\](.*)\[\/countdown\]/gi, "")).replace(/\[item-gallery]/gi, "")).replace(/\[label-icon-new]/gi, "")).replace(/\[pre-order-label]/gi, "")).replace(/\[video\](.*)\[\/video\]/gi, "")).replace(/\[short-description\](.*)\[\/short-description\]/gi, "")).replace(/\[custom_html\](.*)\[\/custom_html\]/gi, "")).replace(/\[tabs\](.*)/gi, "")).replace(/\[tab\](.*)\[\/tab\]/gi, "")).replace(/\[tabs\](.*)\[\/tabs\]/gi, "");
                        if (window.multi_lang && n.indexOf("[lang2]") > 0) {
                            var o = n.split("[lang2]");
                            n = null != jQuery.cookie("language") ? o[translator.current_lang - 1] : o[0]
                        }
                        n = n.split(" ").splice(0, 20).join(" ") + "...", a.find(".product-description").text(n)
                    } else a.find(".product-description").remove();
                    a.find(".product-description").text(n), a.find(".price").html(Shopify.formatMoney(e.price, window.money_format)), a.find(".product-item").attr("id", "product-" + e.id), a.find(".variants").attr("id", "product-actions-" + e.id), a.find(".variants select").attr("id", "product-select-" + e.id), e.compare_at_price > e.price ? (a.find(".compare-price").html(Shopify.formatMoney(e.compare_at_price_max, window.money_format)).show(), a.find(".price").addClass("on-sale")) : (a.find(".compare-price").html(""), a.find(".price").removeClass("on-sale")), e.available ? (a.find(".total-price span").html(Shopify.formatMoney(e.price, window.money_format)), window.use_color_swatch ? t._createvariantquickviewwatch(e, a) : t._createquickviewvariant(e, a)) : (a.find("select, input, .total-price, .dec, .inc, .variants label").remove(), a.find(".add-to-cart-btn-new").text(window.inventory_text.unavailable).addClass("disabled").attr("disabled", "disabled")), a.find(".button").on("click", function() {
                        var e = a.find(".quantity").val(),
                            i = 1;
                        "+" == jQuery(this).text() ? i = parseInt(e) + 1 : e > 1 && (i = parseInt(e) - 1), a.find(".quantity").val(i), a.find(".total-price").length > 0 && t._updatepricequickview()
                    }), window.show_multiple_currencies && "undefined" != typeof Currency && Currency.convertAll(window.shop_currency, jQuery("#currencies .currency.selected").data("currency"), "span.money", "money_format"), t._loadslideimagequickview(e, a), t._addtocartquickview(), t.translateBlock(".product-quickview"), jQuery(".product-quickview").fadeIn(500), jQuery(".product-quickview .total-price").length > 0 && jQuery(".product-quickview input[name=quantity]").on("change", t._updatepricequickview)
                }), !1
            }), jQuery(".product-quickview .overlay, .close-popup, .overlay").live("click", function() {
                return t._closequickview(), e(".ajax-success-cbox").hide(), !1
            })
        },
        _quickshop: function() {
            jQuery(".quickshop a").click(function() {
                console.log("lol");
                var e = jQuery(this).attr("id");
                return console.log(e), Shopify.getProduct(e, function(e) {
                    var i = jQuery("#quickview-popup").html();
                    jQuery(".quick-shop-content" + e.id).html(i);
                    var a = jQuery(".quick-shop-content" + e.id);
                    a.find(".price").html(Shopify.formatMoney(e.price, window.money_format)), a.find(".product-item").attr("id", "product-" + e.id), a.find(".variants").attr("id", "product-actions-" + e.id), a.find(".variants select").attr("id", "product-select-" + e.id), e.compare_at_price > e.price ? (a.find(".compare-price").html(Shopify.formatMoney(e.compare_at_price_max, window.money_format)).show(), a.find(".price").addClass("on-sale")) : (a.find(".compare-price").html(""), a.find(".price").removeClass("on-sale")), e.available ? (a.find(".total-price span").html(Shopify.formatMoney(e.price, window.money_format)), window.use_color_swatch ? t._createvariantquickviewwatch(e, a) : t._createquickviewvariant(e, a)) : (a.find("select, input, .total-price, .dec, .inc, .variants label").remove(), a.find(".add-to-cart-btn-new").text(window.inventory_text.unavailable).addClass("disabled").attr("disabled", "disabled")), window.show_multiple_currencies && "undefined" != typeof Currency && Currency.convertAll(window.shop_currency, jQuery("#currencies .currency.selected").data("currency"), "span.money", "money_format"), t._addtocartquickview(), t.translateBlock(".quick-shop-content"), jQuery(".quick-shop-content").fadeIn(500), jQuery(".quick-shop-content .total-price").length > 0 && jQuery(".quick-shop-content input[name=quantity]").on("change", t._updatepricequickview)
                }), !1
            })
        },
        _updatepricequickview: function() {
            var e = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g,
                i = jQuery(".product-quickview .price").text().match(e);
            if (i || (e = /([0-9]+[.|,][0-9]+)/g, i = jQuery(".product-quickview .price").text().match(e)), i) {
                var t = i[0].replace(/[.|,]/g, "") * parseInt(jQuery(".product-quickview input[name=quantity]").val()),
                    a = Shopify.formatMoney(t, window.money_format);
                a = a.match(e)[0];
                var n = new RegExp(r, "g"),
                    o = jQuery(".product-quickview .price").html().replace(n, a);
                jQuery(".product-quickview .total-price span").html(o)
            }
        },
        _addtocartquickview: function() {
            jQuery(".product-quickview .add-to-cart-btn-new").length > 0 && jQuery(".product-quickview .add-to-cart-btn-new").click(function() {
                var e = jQuery(".product-quickview select[name=id]").val();
                e || (e = jQuery(".product-quickview input[name=id]").val());
                var i = jQuery(".product-quickview input[name=quantity]").val();
                i || (i = 1);
                var a = jQuery(".product-quickview .product-title a").text(),
                    r = jQuery(".product-quickview .quickview-featured-image img").attr("src");
                t._ajaxaddtocart(e, i, a, r), t._closequickview()
            })
        },
        _updateheadercart: function() {
            Shopify.getCart(function(e) {
                t._headercartitem(e)
            })
        },
        _headercartitem: function(i) {
            e(".cart-count").text(i.item_count)
        },
        convertToSlug: function(i) {
            return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        _updateheadercart: function() {
            Shopify.getCart(function(e) {
                t._headercartitem(e)
            })
        },
        _headercartitem: function(i) {
            if (e(".cart-count").text(i.item_count), e("#cartToggle .price-cart-mini").html(Shopify.formatMoney(i.total_price, window.money_format)), e("#dropdown-cart .summary .price").html(Shopify.formatMoney(i.total_price, window.money_format)), e("#dropdown-cart .cart-list").html(""), i.item_count > 0) {
                for (var a = 0; a < i.items.length; a++) {
                    var r = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-inner"><a href="javascript:void(0)" title="Remove Item" class="btn-remove"><i class="cs-font clever-icon-close"></i></a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral"><span class="price">{PRICE}</span>Qty:  {QUANTITY}</div></div></li>';
                    r = (r = (r = (r = (r = (r = (r = r.replace(/\{ID\}/g, i.items[a].id)).replace(/\{URL\}/g, i.items[a].url)).replace(/\{TITLE\}/g, t.translateText(i.items[a].title))).replace(/\{TITLE\}/g, i.items[a].title)).replace(/\{QUANTITY\}/g, i.items[a].quantity)).replace(/\{IMAGE\}/g, Shopify.resizeImage(i.items[a].image, "small"))).replace(/\{PRICE\}/g, Shopify.formatMoney(i.items[a].price, window.money_format)), e("#dropdown-cart .cart-list").append(r)
                }
                e("#dropdown-cart .btn-remove").click(function(i) {
                    e(this).addClass("remove-cart"), i.preventDefault();
                    var a = e(this).parents(".item").attr("id");
                    a = a.match(/\d+/g), Shopify.removeItem(a, function(e) {
                        t._headercartitem(e)
                    })
                }), t._checkcurrency() && "undefined" != typeof Currency && Currency.convertAll(window.shop_currency, jQuery("#currencies .currency.selected").data("currency"), "#dropdown-cart span.money", "money_format")
            }
            t._checkitemdropcart()
        },
        _checkcurrency: function() {
            if ("undefined" != typeof Currency) return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency
        },
        _loadslideimagequickview: function(e, a) {
            var r = Shopify.resizeImage(e.featured_image, "original");
            a.find(".quickview-featured-images").append('<a href="' + e.url + '"><img src="' + r + '" title="' + e.title + '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
            var n = a.find(".more-view ul");
            for (i in e.images) {
                var o = '<li><a href="javascript:void(0)" data-image="' + Shopify.resizeImage(e.images[i], "original") + '"><img src="' + Shopify.resizeImage(e.images[i], "original") + '"  /></a></li>';
                n.append(o)
            }
            n.find("a").click(function() {
                var e = a.find(".quickview-featured-image img"),
                    i = a.find(".quickview-featured-image div");
                e.attr("src") != jQuery(this).attr("data-image") && (e.attr("src", jQuery(this).attr("data-image")), i.show(), e.load(function(e) {
                    i.hide(), jQuery(this).unbind("load"), i.hide()
                }))
            }), n.hasClass("quickview-more-views-owlslider") && t._quickviewthumbslide(n)
        },
        _quickviewthumbslide: function(e) {
            e && e.owlCarousel({
                itemsCustom: [
                    [320, 1],
                    [767, 1],
                    [768, 1],
                    [1024, 1],
                    [1025, 1],
                    [1600, 1]
                ],
                autoPlay: !0,
                navigation: !0,
                navigationText: ['<i class="cs-font clever-icon-arrow-left"></i>', '<i class="cs-font clever-icon-arrow-right"></i>'],
                pagination: !1
            }).css("visibility", "visible")
        },
        convertToSlug: function(e) {
            return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        _createvariantquickviewwatch: function(e, i) {
            if (e.variants.length > 1) {
                for (var t = 0; t < e.variants.length; t++) {
                    var a = '<option value="' + (s = e.variants[t]).id + '">' + s.title + "</option>";
                    i.find("form.variants > select").append(a)
                }
                new Shopify.OptionSelectors("product-select-" + e.id, {
                    product: e,
                    onVariantSelected: selectCallbackQuickview
                });
                var r = window.file_url.substring(0, window.file_url.lastIndexOf("?")),
                    n = (window.asset_url.substring(0, window.asset_url.lastIndexOf("?")), "");
                for (t = 0; t < e.options.length; t++) {
                    var o = !1;
                    /Color|Colour/i.test(e.options[t].name) && (o = !0), n += '<div class="swatch clearfix swatch-' + t + " " + (o ? "color" : "") + '" data-option-index="' + t + '">', n += '<div class="header">' + e.options[t].name + "</div>";
                    for (var c = new Array, d = 0; d < e.variants.length; d++) {
                        var s, l = (s = e.variants[d]).options[t],
                            p = this.convertToSlug(l),
                            u = "swatch-" + t + "-" + p;
                        c.indexOf(l) < 0 && (n += '<div data-value="' + l + '" class="swatch-element ' + (o ? "color" : "") + p + (s.available ? " available " : " soldout ") + '">', n += '<input id="' + u + '" type="radio" name="option-' + t + '" value="' + l + '" ' + (0 == d ? " checked " : "") + (s.available ? "" : " disabled") + " />", n += o ? '<label for="' + u + '" style="background-color: ' + p + "; background-image: url(" + r + p + '.png)"><img class="crossed-out" src="' + r + 'soldout.png" /></label>' : '<label for="' + u + '">' + l + '<img class="crossed-out" src="' + r + 'soldout.png" /></label>', n += "</div>", s.available && jQuery('.product-quickview .swatch[data-option-index="' + t + '"] .' + p).removeClass("soldout").addClass("available").find(":radio").removeAttr("disabled"), c.push(l))
                    }
                    n += "</div>"
                }
                i.find("form.variants > select").after(n), i.find(".swatch :radio").change(function() {
                    var e = jQuery(this).closest(".swatch").attr("data-option-index"),
                        i = jQuery(this).val();
                    jQuery(this).closest("form").find(".single-option-selector").eq(e).val(i).trigger("change")
                }), e.available && (Shopify.optionsMap = {}, Shopify.linkOptionSelectors(e))
            } else {
                i.find("form.variants > select").remove();
                var f = '<input type="hidden" name="id" value="' + e.variants[0].id + '">';
                i.find("form.variants").append(f)
            }
        },
        _createquickviewvariant: function(e, i) {
            if (e.variants.length > 1) {
                for (var t = 0; t < e.variants.length; t++) {
                    var a = e.variants[r],
                        n = '<option value="' + a.id + '">' + a.title + "</option>";
                    i.find("form.variants > select").append(n)
                }
                new Shopify.OptionSelectors("product-select-" + e.id, {
                    product: e,
                    onVariantSelected: selectCallbackQuickview
                }), jQuery(".product-quickview .single-option-selector").selectize(), jQuery(".product-quickview .selectize-input input").attr("disabled", "disabled"), 1 == e.options.length && jQuery(".selector-wrapper:eq(0)").prepend("<label>" + e.options[0].name + "</label>"), i.find("form.variants .selector-wrapper label").each(function(i, t) {
                    jQuery(this).html(e.options[i].name)
                })
            } else {
                i.find("form.variants > select").remove();
                var o = '<input type="hidden" name="id" value="' + e.variants[0].id + '">';
                i.find("form.variants").append(o)
            }
        },
        _closequickview: function() {
            jQuery(".product-quickview").fadeOut(500)
        },
        translateText: function(e) {
            if (!window.enable_multilang || e.indexOf("|") < 0) return e;
            if (window.enable_multilang) {
                var i = e.split("|");
                return translator.isLang2() ? i[1] : i[0]
            }
        },
        translateBlock: function(e) {
            window.enable_multilang && translator.isLang2() && translator.doTranslate(e)
        }
    };
    e(document).ready(function() {
        e(".up-qty").click(function() {
            quantity = e("#quantity").val(), e("#quantity").val(parseInt(quantity) + 1)
        }), e(".down-qty").click(function() {
            quantity = e("#quantity").val(), quantity > 1 && e("#quantity").val(parseInt(quantity) - 1)
        })
    })
}(jQuery);